import { render, staticRenderFns } from "./AuthNewPasswordForm.vue?vue&type=template&id=33297a78&"
import script from "./AuthNewPasswordForm.vue?vue&type=script&lang=js&"
export * from "./AuthNewPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports